import { Controller } from "@hotwired/stimulus"

// Simple controller to stop event propagation
// Usage: data-controller="stop-propagation" data-action="click->stop-propagation#stop"
export default class extends Controller {
  stop(event) {
    event.stopPropagation()
    // Note: We intentionally don't call preventDefault() here to allow
    // form submissions (like button_to) and link clicks to work normally.
    // We only stop propagation to prevent parent elements (like <details>)
    // from receiving the click event.
  }

  disconnect() {
    // Cleanup - nothing to clean up for this simple controller
  }
}
